import { useEffect } from 'react';

interface IProps {
  target?: HTMLElement | null;
  scrollableObject?: HTMLElement | null;
  scrollOffset?: number;
}

const useScrollIntoView = ({ target, scrollableObject, scrollOffset }: IProps): void => {
  useEffect(() => {
    target?.scrollIntoView({ block: 'center' });

    if (scrollableObject) {
      const { height } = scrollableObject.getBoundingClientRect();
      if (scrollOffset && scrollableObject.scrollTop < height + scrollOffset) {
        scrollableObject.scrollTo(0, scrollableObject.scrollTop - scrollOffset);
      }
    }
  }, [target, scrollableObject, scrollOffset]);
};

export { useScrollIntoView };
